<template>
  <ValidationObserver @submit="addNew">
    <UiModalContainer
      footer-classes="flex justify-end gap-3"
      :disable-position-center="true"
      :modal-show="modal"
      :modal-width="60"
      @handleClick="handleClick"
    >
      <template v-slot:header>
        <span>Attach File</span>
      </template>
      <div class="pb-5">
        <div class="showModal-body py-3 px-6 text-xs md:text-base">
          <div class="flex lg:gap-3 mt-3 flex-col lg:flex-row">
            <div class="flex flex-1 gap-2">
              <div class="font-bold">Title</div>
              <div class="text-primary-grey-light">:{{ currentExpense.title }}</div>
            </div>
            <div class="flex flex-1 gap-2">
              <div class="font-bold">Amount</div>
              <div class="text-primary-grey-light">:{{ currentExpense.amount }}</div>
            </div>
          </div>
          <div class="flex lg:gap-3 flex-col lg:flex-row flex-wrap mt-5">
            <div class="flex flex-1 gap-2">
              <div class="font-bold">Spent At</div>
              <div class="text-primary-grey-light">:{{ formatDate(currentExpense.spent_at) }}</div>
            </div>
            <div class="flex flex-1 gap-2">
              <div class="font-bold">Payment through</div>
              <div class="text-primary-grey-light">:{{ currentExpense.payment_method }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="px-6">
        <UiMultiUploadFile
          id="input-type-file-single"
          v-model="attachNewFile"
          :rules="imageRules"
          name="UPLOAD"
          :current-file="currentExpense.expense_attachments"
        />
      </div>
      <template v-slot:footer>
        <div class="flex space-x-2 rtl:gap-x-4">
          <UIButton
            class="sm-button"
            button="primary"
            :disabled="isLoading"
            @click="handleClick('cancel')"
          >
            Cancel
          </UIButton>
          <UIButton class="sm-button" button="primary" :disabled="isLoading">
            <template v-if="isLoading">
              <Loader />
            </template>
            <template v-else>Save</template>
          </UIButton>
        </div>
      </template>
    </UiModalContainer>
  </ValidationObserver>
</template>

<script>
import UiModalContainer from '@components/UiElements/UiModalContainer.vue'
import { formatDate } from '@src/utils/moment.util.js'
import { mapActions, mapState } from 'vuex'
import UiMultiUploadFile from '@/src/components/UiElements/UiMultiUploadFile.vue'
import RULE_CONSTANTS from '@src/constants/rule.constants.js'
import { Form as ValidationObserver } from 'vee-validate'
import UIButton from '@src/components/UiElements/UIButton.vue'

export default {
  components: {
    UiModalContainer,
    UiMultiUploadFile,
    ValidationObserver,
  },
  props: {
    modal: { type: Boolean },
    currentExpense: { type: Object, default: () => {} },
  },
  emits: ['toggle'],
  data() {
    return {
      attachNewFile: [],
      isLoading: false,
    }
  },
  computed: {
    imageRules() {
      return `${RULE_CONSTANTS.SIZE}|${RULE_CONSTANTS.FILE_LIMIT}`
    },
  },

  methods: {
    formatDate,
    handleClick(eventName) {
      switch (eventName) {
        case 'cancel':
          this.$emit('toggle')
          break
      }
    },

    addNew() {
      this.isLoading = true
      const data = new FormData()
      if (this.attachNewFile.length) {
        for (const file of this.attachNewFile) {
          data.append('expense_id', this.currentExpense.id)
          data.append('files[]', file)
        }
        this.addExtraAttachment(data).then(() => {
          this.$emit('toggle', true)
        })
      } else {
        this.handleClick('cancel')
      }
    },
    ...mapActions('expense', ['addExtraAttachment']),
  },
}
</script>
